import { render, staticRenderFns } from "./HealthAndCare.vue?vue&type=template&id=71408eca&"
import script from "./HealthAndCare.vue?vue&type=script&lang=js&"
export * from "./HealthAndCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports